import { BrandIdStorage } from './classes/BrandIdStorage';
import { TokenStorage } from './classes/TokenStorage';

export const tokenStorage = new TokenStorage();
export const brandIdStorage = new BrandIdStorage();
